module.exports = __webpack_public_path__ + "static/media/ca_member_white.5affd98c.png";